import { AddAiTaskOperationResult } from "./AddAiTaskOperationResult.js";

/**
 * Result returned when adding an embeddings generation ETL task.
 */
export interface AddEmbeddingsGenerationOperationResult extends AddAiTaskOperationResult {
    // Inherits all properties from AddAiTaskOperationResult
}

